import { AccordionDetails, AccordionSummary, styled } from '@mui/material';

export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
  padding: theme.spacing(3, 4),
  transition: 'background-color 0.25s ease',

  '&:hover, &.Mui-expanded': {
    backgroundColor: '#F7F5F7',
  },

  '& > .MuiAccordionSummary-content': {
    margin: 0,
  },
}));

export const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(4, 4),

  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(5, 4),
  },
}));
